import styled from 'styled-components';

import {
  Scrollbar as StyledScrollbar,
  ScrollbarWrapper as StyledWrapper,
} from './horizontal-scroller.styled.default';

export * from './horizontal-scroller.styled.default';

export const ScrollbarWrapper = styled(StyledWrapper)`
  background: ${Styles.color.grey.five};
`;

export const Scrollbar = styled(StyledScrollbar)`
  background: ${Styles.color.cardBackground};
`;
